<template>
  <div class="app">
    <AppHeader fixed>
      <div class="d-flex">
        <SidebarToggler class="d-lg-none mx-2" display="md" mobile/>
        <SidebarToggler class="d-md-down-none mx-2" display="lg"/>
        <b-link class="navbar-brand mx-2" to="#">
          <!--<img class="navbar-brand-full" src="/img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
          <img class="navbar-brand-minimized" src="/img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">-->
          <h4 class="m-0 logo">{{app_name}}</h4>
        </b-link>

        <b-navbar-nav class="d-md-down-none">
          <b-nav-item
            v-if="dashboard"
            class="px-3"
            to="/dashboard"
            exact
          >داشبورد
          </b-nav-item>
          <b-nav-item
            v-if="base === true && isCompany === true"
            class="px-3"
            id="base-product"
            :to="baseUrl"
            @click="_setNavItems('base')"
          >اطلاعات پایه
          </b-nav-item>
          <b-nav-item
            v-if="inventory === true && isCompany === true"
            class="px-3"
            :to="inventoryUrl"
            @click="_setNavItems('inventory')"
          >انبار
          </b-nav-item>

          <b-nav-item
            v-if="order"
            class="px-3"
            :to="orderUrl"
            @click="_setNavItems('order')"
          >سفارشات
          </b-nav-item>
          <b-nav-item
            v-if="planning"
            class="px-3"
            :to="planningUrl"
            @click="_setNavItems('planning')"
            exact
          >برنامه ریزی
          </b-nav-item>
          <b-nav-item
            v-if="works"
            class="px-3"
            :to="worksUrl"
            @click="_setNavItems('works')"
            exact
          >مدیریت تولید
          </b-nav-item>
          <b-nav-item
            v-if="pm"
            class="px-3"
            :to="pmUrl"
            @click="_setNavItems('pm')"
            exact
          >نگهداری تعمیرات
          </b-nav-item>

          <!-- <b-nav-item class="px-3" to="/trust-funds">صندوق ها</b-nav-item>-->


          <!--<b-nav-item-->
          <!--v-if="productionManagement"-->
          <!--class="px-3"-->
          <!--to="/production-management"-->
          <!--exact-->
          <!--&gt;مدیریت تولید-->
          <!--</b-nav-item>-->
          <!--<b-nav-item-->
          <!--v-if="accountant"-->
          <!--class="px-3"-->
          <!--:to="accountantUrl"-->
          <!--@click="_setNavItems('accountant')"-->
          <!--&gt;حسابداری-->
          <!--</b-nav-item>-->
          <!--<b-nav-item-->
          <!--v-if="biAccess"-->
          <!--class="px-3"-->
          <!--:to="biAccessUrl"-->
          <!--@click="_setNavItems('biAccess')"-->
          <!--exact-->
          <!--&gt;حقوق و دستمزد-->
          <!--</b-nav-item>-->
          <b-nav-item
            v-if="useradmin && (companyId ==1 || username ==='superadmin')"
            class="px-3"
            :to="useradminUrl"
            @click="_setNavItems('useradmin')"
          >مدیریت کاربرها
          </b-nav-item>
        </b-navbar-nav>
      </div>
      <div>
        <b-navbar-nav class="mr-auto">
          <div class="user-info">
            <span>{{company}}</span>/
            <span>{{post}}</span>/
            <span>{{username}}</span>
          </div>
          <DefaultHeaderDropdownAccnt/>
        </b-navbar-nav>
      </div>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SideNav :navItems="navItems"></SideNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://badian-co.ir">چرخونه/ بدیعان اندیشه</a>
      </div>
      <div class="mr-auto">
        <span class="mr-1">Badian Andisheh</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
  import nav from "@/_nav";
  import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb
  } from "@coreui/vue";
  import DefaultAside from "./DefaultAside";
  import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
  import SideNav from "./Sidebar";
  import EventBus from "../bus.js";
  import Constants from "../Constants";

  export default {
    name: "full",
    components: {
      SideNav,
      // AsideToggler,
      AppHeader,
      AppSidebar,
      // AppAside,
      TheFooter,
      Breadcrumb,
      // DefaultAside,
      DefaultHeaderDropdownAccnt,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer
    },
    data() {
      return {
        app_name: "",
        // nav: nav.items,
        company: "",
        post: "",
        username: "",
        navItems: [],
        show: true,
        base: false,
        baseUrl: "/outsource",
        accountant: false,
        accountantUrl: "/accounting-documents-list",
        inventory: false,
        inventoryUrl: "/documents",
        order: false,
        orderUrl: "/order",
        useradmin: false,
        useradminUrl: "/users",
        biAccess: false,
        biAccessUrl: "/comming-soon",
        works: false,
        worksUrl: "/works-home",
        dashboard: false,
        planning: false,
        planningUrl: "/planning-orders",
        pm: false,
        pmUrl: "/devices",
        productionManagement: false,
        companyId: null,
        outSourceId: null,
        isCompany: false,
      };
    },
    mounted() {
      this.app_name = Constants.APP_NAME;
      // console.log("before" , this.base)
      this.base = this.accountant = this.inventory = this.useradmin = this.productionManagement = this.biAccess = this.works = this.dashboard = this.order = this.planning = this.pm = false;
      this.companyId = localStorage.getItem('companyId');
      this.outSourceId = localStorage.getItem('outSourceId');
      this.checkCompany();
      // console.log(this.companyId, this.base);
      let accesses = JSON.parse(localStorage.getItem("accesses"));
      let navItemType = localStorage.getItem("navItemsType");
      let postId = localStorage.getItem("postId");
      if (accesses && accesses.map) {
        let names = accesses.map(a => {
          return a.page.persianName;
        });
        if (postId === "1" || names.includes("داشبورد")) {
          this.dashboard = true;
        }
        if (postId === "3006" || names.includes("مدیریت تولید")) {
          this.productionManagement = true;
        }
        // console.log(names);
        if (
          this.companyId === '1' ||
          postId === "3006" ||
          names.includes("شرکت ها") ||
          names.includes("شرکت های خارجی") ||
          names.includes("الگوها") ||
          names.includes("وضعیت سفارش")
        ) {

          this.base = true;
          this.baseUrl = names.includes("شرکت های خارجی")
            ? "/outsource"
            : names.includes("واحدها")
              ? "/units"
              : names.includes("شرکت ها")
                ? "/company"
                : names.includes("الگوها")
                  ? "/product-patterns"
                  : names.includes("وضعیت سفارش")
                    ? "/store-order-status"
                    : "/home";
        }
        if (
          postId === "3006" ||
          names.includes("سرفصل حساب ها") ||
          names.includes("اسناد حسابداری") ||
          names.includes("بانک ها") ||
          names.includes("حساب های بانکی")
        ) {
          this.accountant = true;
          this.accountantUrl = names.includes("اسناد حسابداری")
            ? "/accounting-documents-list"
            : names.includes("سرفصل حساب ها")
              ? "/accounts-titles"
              : names.includes("بانک ها")
                ? "/banks"
                : names.includes("حساب های بانکی")
                  ? "/bank-accounts"
                  : "/home";
        }
        if (
          postId === "3006" ||
          names.includes("اسناد انبار") ||
          names.includes("سفارش فروش") ||
          names.includes("سفارش خرید") ||
          names.includes("کارتکس کالا") ||
          names.includes("اطلاعات پایه") ||
          names.includes("محصولات") ||
          names.includes("واحدها") ||
          names.includes("نوع سند") ||
          names.includes("عملیات مقداری انبار") ||
          //names.includes("عملیات ریالی انبار") ||
          names.includes("گزارشات مقداری انبار")
        //names.includes("گزارشات ریالی انبار")
        ) {
          this.inventory = true;
          this.order = true;
          if (postId !== "3006") {
            this.inventoryUrl = names.includes("اسناد انبار")
              ? "/documents"
              : names.includes("سفارش فروش")
                ? "/order"
                : names.includes("سفارش خرید")
                  ? "/purchase-order"
                  : names.includes("کارتکس کالا")
                    ? "/kardex"
                    : names.includes("نوع سند")
                      ? "/voucher-type"
                      : names.includes("محصولات")
                        ? "/products"
                        : names.includes("اطلاعات پایه")
                          ? "/"
                          : names.includes("عملیات مقداری انبار")
                            ? "/"
                            //: names.includes("عملیات ریالی انبار")
                            // ? "/"
                            : names.includes("گزارشات مقداری انبار")
                              ? "/"
                              // : names.includes("گزارشات ریالی انبار")
                              //   ? "/"
                              : "/home";
          }
        }
        if (
          postId === "3006" ||
          names.includes("کاربر ها") ||
          names.includes("سمت ها") ||
          names.includes("اشخاص")
        ) {
          this.useradmin = true;
          this.useradminUrl = names.includes("کاربر ها")
            ? "/users"
            : names.includes("سمت ها")
              ? "/access"
              : names.includes("اشخاص")
                ? "/persons"
                : "/home";
        }
        if (
          postId === "1" ||
          names.includes("اطلاعات پایه") ||
          names.includes("اطلاعات پرسنلی") ||
          names.includes("کارکرد/بدهی") ||
          names.includes("گزارشات") ||
          names.includes("محاسبات")
        ) {
          this.biAccess = true;
          this.biAccessUrl = names.includes("اطلاعات پایه")
            ? "/bi-access"
            : names.includes("اطلاعات پرسنلی")
              ? "/bi-access"
              : names.includes("کارکرد/بدهی")
                ? "/bi-access"
                : names.includes("گزارشات")
                  ? "/bi-access"
                  : "comming-soon"
          /*names.includes("محاسبات")
            ? "/bi-access"
            : "/home";*/
        }
        // task-flow subset

        /*if (postId === "1" || names.includes("الگو گذاری")) {
          this.patterns = true;
          this.patternsUrl = names.includes("الگو گذاری")
          if ("patterns") {
            this.patternsUrl = names.includes("الگو گذاری")
          } else {
            this.patternsUrl = names.includes("الگو گذاری")
          }
        }*/

        if (
          postId === "1" ||
          names.includes("کارها") ||
          names.includes("سفارشات مشتری")
        ) {
          // console.log(localStorage.getItem("outSourceId"))
          this.works = true;
          this.worksUrl = names.includes("کارها") ? "works-home" : names.includes("کارها")
        }
        if (
          postId === "1" ||
          names.includes("کارها")
        ) {
          this.planning = true;
          this.planningUrl = names.includes("برنامه ریزی") ? "/planning-orders" : names.includes("برنامه ریزی")
        }
        if (
          postId === "1" ||
          names.includes("کارها")
        ) {
          this.pm = true;
          this.pmUrl = names.includes("برنامه ریزی") ? "/devices" : names.includes("برنامه ریزی")
        }
      }


      if (navItemType == null) {
        navItemType = this.base
          ? "base"
          : this.accountant
            ? "accountant"
            : this.inventory
              ? "inventory"
              : this.useradmin
                ? "useradmin"
                : this.biAccess
                  ? "biAccess"
                  : this.works
                    ? "works-home"
                    : this.planning
                      ? "planning-orders"
                      : this.pm
                        ? "devices"
                        : null;
      }
      this._setNavItems(navItemType);
      EventBus.$on("changeNavItems", type => {
        this._setNavItems(type);
      });
      this.company = localStorage.getItem("company");
      this.companyId = localStorage.getItem("companyId");
      this.post = localStorage.getItem("post");
      this.username = localStorage.getItem("username");
    },
    methods: {
      _setNavItems(type) {
        this.navItems = setNavItems(type);
        localStorage.setItem("navItemsType", type);
      },
      checkCompany() {

        if (this.companyId === null || this.companyId === "null") {
          this.isCompany = false
        } else {
          this.isCompany = true
        }
      },
    },
    computed: {
      nav() {
        let items = this.navItems;
        return items;
      },
      name() {
        return this.$route.name;
      },
      list() {
        return this.$route.matched.filter(
          route => route.name || route.meta.label
        );
      }
    },
    watch: {
      base(old, val) {
        // console.log('watch', val)
      }
    }
  };
</script>


